/**
 * This calculates the spacing for the
 * grid container component based on the viewsize
 */

import { isWidthUp } from "@material-ui/core/withWidth";

function calculateSpacing(width) {
  if (isWidthUp("lg", width)) {
    return 1;
  }
  if (isWidthUp("md", width)) {
    return 1;
  }
  if (isWidthUp("sm", width)) {
    return 1;
  }
  return 1;
}

export default calculateSpacing;
